<template>
  <div class="powerList">
    <en-table-layout :tableData="tableData.data" :loading="loading">
      <template slot="toolbar">
        <el-form-item label="售后类型" class="col-auto">
          <el-select style="width: 100px" v-model="params.refuse_type" size="small" placeholder="请选择" clearable>
            <el-option label="全部" value="" />
            <el-option label="仅退款" value="RETURN_MONEY"></el-option>
            <el-option label="商家退款" value="SHOP_REFUND"></el-option>
            <el-option label="退款退货" value="RETURN_GOODS" />
            <el-option label="换货" value="EXCHANGE_GOODS" />
            <el-option label="维修" value="REPAIR_GOODS" />
            <el-option label="商家退款" value="SHOP_REFUND" />
            <el-option label="换新" value="RETURN_REPLACE_GOODS" />
            <el-option label="更换商品" value="REPLACE_GOODS" />
            <el-option label="售后补发" value="AFTER_REISSUE" />
          </el-select>
        </el-form-item>

        <el-form-item label="售后状态" class="col-auto">
          <el-select style="width: 120px" v-model="params.refund_status" size="small" placeholder="请选择" clearable>
            <el-option label="全部" value="" />
            <el-option label="申请中" value="APPLY" />
            <el-option label="待寄回" value="WAIT_SEND_BACK" />
            <el-option label="已寄回" value="SEND_BACK" />
            <el-option label="已完成" value="COMPLETED" />
            <el-option label="已拒绝" value="REFUSE" />
          </el-select>
        </el-form-item>
        <el-form-item label="来源应用" class="col-auto">
          <el-select style="width: 100px" v-model="params.mall_type" size="small" placeholder="请选择" clearable>
            <el-option label="全部" value="" />
            <el-option label="现金商城" :value="2" />
            <el-option label="套餐卡商城" :value="3" />
            <el-option label="AI智能套餐卡商城" :value="4" />
            <el-option label="双选商城" :value="5" />
            <el-option label="一件代发商城" :value="7" />
            <el-option label="小程序商城" :value="6" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属订单类型" class="col-auto">
          <el-select style="width: 100px" v-model="params.trade_type" size="small" placeholder="请选择" clearable>
            <el-option label="全部" value="" />
            <el-option label="普通商品订单" :value="1" />
            <el-option label="礼包订单" :value="2" />
            <el-option label="计次卡订单" :value="3" />
            <el-option label="宅配卡订单" :value="4" />
            <el-option v-if="isShowJinLi" label="锦礼商城订单" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="提交时间" class="col-auto">
          <el-date-picker style="width: 220px" v-model="advancedForm.order_time_range" type="daterange" align="center"
            :editable="false" unlink-panels size="small" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="timestamp"
            :picker-options="{ disabledDate(time) { return time.getTime() > Date.now() }, shortcuts: MixinPickerShortcuts }"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-select style="width: 130px" v-model="params.keywordType" size="small" placeholder="请选择" clearable>
            <el-option label="根据售后单号" value="sn" />
            <el-option label="根据订单编号" value="trade_sn" />
            <el-option label="根据商品名称" value="goods_name" />
            <el-option label="根据下单账号" value="member_name" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input style="width: 150px" v-model="params.keywordValue" size="small" placeholder="根据关键字类型进行搜索"
            clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="advancedSearchEvent()" size="small" type="primary">搜索</el-button>
        </el-form-item>
      </template>

      <template slot="table-columns">
        <!--图片-->
        <el-table-column label="图片" fixed="left" min-width="88" max-width="250">
          <template slot-scope="scope">
            <img :src="scope.row.goods_image" style="width: 65px">
          </template>
        </el-table-column>
        <!--名称-->
        <el-table-column label="名称" min-width="100" max-width="250" fixed="left" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.goods_name }}
          </template>
        </el-table-column>
        <!-- <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column> -->
        <!--售后单号-->
        <el-table-column prop="sn" label="售后单号" width="130" fixed="left" />
        <!--订单编号-->
        <el-table-column prop="trade_sn" label="订单编号" width="130" fixed="left" :show-overflow-tooltip="true" />
        <!--订单来源-->
        <el-table-column label="订单来源" min-width="200" max-width="400" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.enterprise_name }}-
            {{ scope.row.shop_name }}
          </template>
        </el-table-column>
        <!--订单金额-->
        <!--      <el-table-column-->
        <!--        prop="refund_price"-->
        <!--        label="订单金额"-->
        <!--        width="100"-->
        <!--      >-->
        <!--        <template slot-scope="scope">-->
        <!--          {{ scope.row.refund_shop_price | unitPrice('￥') }}-->
        <!--        </template>-->
        <!--      </el-table-column>-->
        <el-table-column prop="shop_name" label="来源应用" width="180">
          <template slot-scope="{row}">
            <span v-if="row.mall_type == 2">现金商城</span>
            <span v-if="row.mall_type == 3">套餐卡商城</span>
            <span v-if="row.mall_type == 4">AI智能套餐卡商城</span>
            <span v-if="row.mall_type == 5">双选商城</span>
            <span v-if="row.mall_type == 7">一件代发商城</span>
            <span v-if="row.mall_type == 6">小程序商城</span>
          </template>
        </el-table-column>
        <!--下单账号-->
        <el-table-column prop="member_name" label="下单账号" width="150" class-name="font-family-tttgb">
          <template slot-scope="{row}">
            <p>{{ row.mobile || '' }}</p>
            <p>{{ row.login_account || '' }}</p>
          </template>
        </el-table-column>

        <!--提交时间-->
        <el-table-column prop="create_time" :formatter="MixinUnixToDate" label="提交时间" width="150"
          :show-overflow-tooltip="true" />
        <!--售后类型-->
        <el-table-column prop="refuse_type_text" label="售后类型" width="80" fixed="right" />
        <!--售后状态-->
        <el-table-column label="售后状态" width="100" fixed="right">
          <template slot-scope="scope">
            <span>{{ scope.row.refund_status_text }}</span><br>
            <el-tooltip v-if="scope.row.refund_status === 'AFTER_REISSUE'" style="margin-left: 4px;" class="item"
              effect="dark" content="待补发是指供应商已经售后审核通过，待重新补发商品的状态。待补发的售后状态归类到【已寄回】的售后状态筛选项中。" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            <span v-if="scope.row.refund_reason === '线下售后'" style="color: red;">
              (京东自动退回)
            </span>
            <span v-if="scope.row.refund_reason === '京东取消订单'" style="color: red;">
              (京东取消订单)
            </span>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column label="操作" :render-header="renderHeader" :key="Math.random()" fixed="right">
          <template slot-scope="scope">
            <div class="operate" style="white-space: nowrap; display: inline-block">
              <el-button
                v-if="scope.row.is_cake_order == 1 && scope.row.after_sale_operate_allowable.allow_seller_approval"
                type="primary" size="mini" @click="examineRefund(scope.row)">
                审核
              </el-button>
              <el-button type="primary" size="mini"
                @click="handleOperateOrder(scope.$index, scope.row)">查看订单</el-button>
              <el-button v-if="scope.row.is_cake_order == 1 && scope.row.refund_status == 'SEND_BACK'" type="primary"
                size="mini" @click="handleWareHousing(scope.row)">
                确认收货
              </el-button>
            </div>
          </template>
        </el-table-column>
      </template>
      <el-pagination slot="pagination" @size-change="handlePageSizeChange" @current-change="handlePageCurrentChange"
        :current-page="tableData.page_no" :page-sizes="MixinPageSizes" :page-size="tableData.page_size"
        :layout="MixinTableLayout" :total="tableData.data_total" background>
      </el-pagination>
    </en-table-layout>
    <!--退款、退货审核-->
    <x-dialog :proxy="enterRulesProxy">
      <el-form :model="baseInfoForm" ref="baseInfoForm" class="auditForm" label-width="120px" :rules="baseInfoRules">
        <p style="margin-left:52px;color: red;" class="marginNone">注意：蛋糕类商品维权订单需蛋糕叔叔接口方同意后方可操作同意售后。</p>
        <el-form-item class="marginNone" label="售后单号">
          {{ refundInfo.sn }}
        </el-form-item>
        <el-form-item class="marginNone" label="关联订单">
          {{ refundInfo.trade_sn }}
        </el-form-item>
        <el-form-item class="marginNone" label="申请时间">
          {{ refundInfo.create_time | unixToDate }}
        </el-form-item>
        <el-form-item class="marginNone" label="售后状态">
          {{ refundInfo.refund_status_text }}
        </el-form-item>
        <el-form-item class="marginNone" label="服务类型">
          {{ refundInfo.refuse_type_text }}
        </el-form-item>
        <el-form-item class="marginNone" label="申请原因">
          {{ refundInfo.refund_reason }}
        </el-form-item>
        <el-form-item class="marginNone" label="问题描述">
          {{ refundInfo.customer_remark }}
        </el-form-item>
        <el-form-item class="marginNone" label="图片凭证">
          <div style="flex-wrap: wrap; width: 100%; align-content: flex-start;">
            <el-image v-for="(item, index) in refund_img" :key="index" style="width: 100px; height: 100px" :src="item"
              :preview-src-list="refund_img">
            </el-image>
          </div>
        </el-form-item>
        <el-form-item label="审核" prop="agree">
          <el-radio v-model="baseInfoForm.agree" :label="1">同意</el-radio>
          <el-radio v-model="baseInfoForm.agree" :label="0">拒绝</el-radio>

        </el-form-item>

        <el-form-item v-if="baseInfoForm.agree == 1" label="售后商品" prop="return_num">
          {{ refundInfo.name }}
          <el-input-number :disabled="refundInfo.shop_combo_id" v-model="baseInfoForm.return_num" :step="1"
            step-strictly size="mini" controls-position="right" :min="1" :max="refundInfo.num"></el-input-number>个
        </el-form-item>
        <el-form-item v-if="baseInfoForm.agree == 1" label="售后类型" prop="refuse_type">
          <el-radio-group v-model="baseInfoForm.refuse_type">
            <template v-if="refundInfo.shop_combo_id">
              <!-- <el-radio label="EXCHANGE_GOODS">换货（礼包类商品）</el-radio> -->
              <el-radio label="RETURN_REPLACE_GOODS">换新（礼包类商品）</el-radio>
            </template>
            <template v-else>
              <el-radio v-if="refundInfo.is_need_send !== 0" label="RETURN_GOODS">退货退款</el-radio>
              <el-radio label="RETURN_MONEY">仅退款</el-radio>
            </template>
          </el-radio-group>

          <span v-if="baseInfoForm.refuse_type === 'RETURN_GOODS'" class="text-tips">(退货退款需收到退货后才处理退款)</span>
        </el-form-item>
        <el-form-item label="原因" v-if="baseInfoForm.agree == 0">
          <!-- <textarea style="width: 90%;color: #1a1818b8;line-height: 20px;" v-model="refund_reason" maxlength="100"
            placeholder="拒绝原因最多不超100字。"></textarea> -->
          <el-input style="width: 80%" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
            v-model="baseInfoForm.reason" placeholder="原因最多不超100字。" maxlength="100"></el-input>
        </el-form-item>
        <template v-if="baseInfoForm.refuse_type !== 'RETURN_MONEY'">
          <p style="margin-left:55px" v-if="baseInfoForm.agree == 1">退货信息</p>
          <el-form-item v-if="baseInfoForm.agree == 1" label="收货人" prop="seller_shipping_name">
            <el-input style="width: 200px;" v-model="baseInfoForm.seller_shipping_name" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item v-if="baseInfoForm.agree == 1" label="联系电话" prop="seller_shipping_mobile">
            <el-input style="width: 200px;" v-model="baseInfoForm.seller_shipping_mobile" maxlength="50"></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="baseInfoForm.agree == 1" label="联系地址" prop="region" class="area-select">
            <en-region-picker :api="MixinRegionApi" :default="areas" @changed="handleChangeArea"></en-region-picker>
          </el-form-item> -->
          <el-form-item v-if="baseInfoForm.agree == 1" label="收件地址" prop="seller_shipping_address">
            <el-input style="width: 80%" v-model="baseInfoForm.seller_shipping_address" maxlength="100"></el-input>
          </el-form-item>
        </template>
      </el-form>
    </x-dialog>
  </div>
</template>

<script>
import * as API_order from "@/api/order";
import * as API_refund from "@/api/refund";
import { Foundation } from "@/../ui-utils";
import EnTableLayout from "../../../../ui-components/TableLayout/src/main";
import { $xDialog } from "@/components/x-dialog/dialog.proxy";
import xDialog from '@/components/x-dialog/x-dialog'
export default {
  name: "powerList",
  components: { EnTableLayout, xDialog },
  data () {
    return {
      radio: 3,
      // 地区id数组
      areas: [],
      // 列表loading状态
      loading: false,
      // 列表参数
      params: {
        page_no: 1,
        page_size: 20,
        mall_type: "",//来源应用
        shop_member_type: 1,
        refund_status: "",
        refuse_type: "",
        keywordType: 'sn',
        keywordValue: '',
        trade_type: "",//所属订单类型
      },
      // 列表数据
      tableData: {},
      // 高级搜索数据
      advancedForm: {},
      /** 当前退款/货 信息 */
      refundInfo: {

      },
      baseInfoForm: {
        agree: 1,//审核类型 1：通过 2：拒绝
        return_num: '',//售后商品数量
        refuse_type: 'RETURN_GOODS',//售后类型
        reason: '',//拒绝原因
        seller_shipping_name: '',//收件人
        seller_shipping_mobile: '',//联系电话
        seller_shipping_address: '',//收件地址
        sku_id: '',//sku_id
      },
      baseInfoRules: {
        agree: [
          { required: true, message: '请选择审核类型', trigger: 'change' }
        ],
        return_num: [
          { required: true, message: '请输入售后商品数量', trigger: 'blur' }
        ],
        refuse_type: [
          { required: true, message: '请选择售后类型', trigger: 'change' }
        ],
        seller_shipping_name: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        seller_shipping_mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        seller_shipping_address: [
          { required: true, message: '请输入收件地址', trigger: 'blur' }
        ],
      },
      refund_img: [],
      orderType: 1,
      enterRulesProxy: $xDialog.create({
        title: '操作',
        width: '800px',
        wrapperClass: 'enter-rules-wrapper',
        beforeConfirm: this.handleRefund,
        beforeCancel: () => this.enterRulesProxy.dismiss()
      })
    }
  },
  filters: {
    tradeformFilter (status) {
      const statusMap = {
        1: "普通商品订单",
        2: "礼包订单",
        3: "计次卡订单",
        4: "宅配卡订单",
        5: "锦礼商城订单"
      };
      return statusMap[status];
    },
    paymentTypeFilter (val) {
      return val === "ONLINE" ? "在线支付" : "线下支付";
    }
  },
  mounted () {
    this.GET_OrderList();
  },
  activated () {
    this.GET_OrderList();
  },
  methods: {
    // 表头部重新渲染
    renderHeader (h, { column, $index }) {
      setTimeout(() => {
        // 获取操作按钮组的元素
        const opts = document.getElementsByClassName('operate');
        let widthArr = [];
        // 取操作组的最大宽度
        Array.prototype.forEach.call(opts, function (item) {
          if (item.innerText || item.children) {
            widthArr.push(item.offsetWidth);
          }
        });
        // 重新设置列标题及宽度属性
        if (widthArr.length > 0) {
          column.width = Math.max(...widthArr) + 24;
        } else {
          column.width = 0;
        }
      }, 1)
      return h('span', column.label);
    },
    /** 获取地址信息 */
    getAdress () {
      API.getBackAdress().then(response => {

        if (response.refund_province_id) {
          this.areas = [response.refund_province_id, response.refund_city_id, response.refund_county_id || -1, response.refund_town_id || -1]
        }
      })
    },
    /** 操作地区选择器改变时 触发*/
    handleChangeArea (val) {
      this.baseInfoForm.region = val.last_id;
    },
    /** 打开审核弹窗 */
    examineRefund (row) {
      API_refund.getRefundDetail(row.sn).then((response) => {
        this.refund_img = []
        this.refund_reason = '';
        this.enterRulesProxy.display();
        this.refundInfo = response.refund

        this.refundInfo.shop_combo_id = response.trade_do.shop_combo_id
        this.refundInfo.name = response.order_items_do.name
        this.refundInfo.num = response.order_items_do.num

        this.refundMoney = response.refund.refund_shop_price
        if (this.refundInfo.refund_img) {
          this.refund_img = this.refundInfo.refund_img.split(',')
        }
        // 初始化表单
        this.baseInfoForm = {
          sn: row.sn,
          agree: 1,//审核类型 1：通过 2：拒绝
          refund_shop_price: 20,//退款金额（无意义占位符）
          return_num: '',//售后商品数量
          refuse_type: 'RETURN_GOODS',//售后类型
          reason: '',//拒绝原因
          seller_shipping_name: '',//收件人
          seller_shipping_mobile: '',//联系电话
          seller_shipping_address: '',//收件地址
          sku_id: response.order_items_do.product_id
        }
        this.baseInfoForm.return_num = this.refundInfo.num
        if (this.refundInfo.shop_combo_id) {//如果是礼包  默认选中换新
          this.baseInfoForm.refuse_type = 'RETURN_REPLACE_GOODS'
        }
        if (this.refundInfo.is_need_send == 0) {//如果仅退款  就默认选中
          this.baseInfoForm.refuse_type = 'RETURN_MONEY'
        }
      })
    },
    /** 审核操作 */
    handleRefund () {
      let { promise, resolve, reject } = Promise.withResolvers();
      this.$refs.baseInfoForm.validate((valid) => {
        if (valid) {
          API_refund.auditRefund(this.baseInfoForm.sn, this.baseInfoForm).then(() => {
            this.GET_OrderList();
            resolve(true)
          }).catch(error => {
            reject(false)
          })
          resolve(true)
        } else {
          reject(false)
        }
      })
      return promise
    },
    /** 确认收货操作 */
    handleWareHousing (row) {
      this.$confirm(`请确认是否收到货物，否则会钱财两空`, '操作', {
        type: 'info',
      }).then(() => {
        API_refund.confirmReceipt(row.sn).then(() => {
          this.$message.success("确认收货成功");
          this.GET_OrderList();
        });
      });
    },
    /** 分页大小发生改变 */
    handlePageSizeChange (size) {
      this.params.page_size = size;
      this.GET_OrderList();
    },

    /** 分页页数发生改变 */
    handlePageCurrentChange (page) {
      this.params.page_no = page;
      this.GET_OrderList();
    },

    /** 搜索事件触发 */
    searchEvent (data) {
      this.params = {
        ...this.params,
        order_sn: data,
      };
      Object.keys(this.advancedForm).forEach((key) => delete this.params[key]);
      this.params.page_no = 1;
      this.GET_OrderList();
    },

    /** 高级搜索事件触发 */
    advancedSearchEvent () {
      this.params = {
        ...this.params,
        ...this.advancedForm,
      };
      delete this.params.start_time;
      delete this.params.end_time;
      if (this.advancedForm.order_time_range) {
        this.params.start_time = this.advancedForm.order_time_range[0] / 1000;
        this.params.end_time = this.advancedForm.order_time_range[1] / 1000;
      }

      //delete this.params.order_sn
      delete this.params.order_time_range;
      this.params.page_no = 1;
      this.GET_OrderList();
    },

    /** 查看、操作订单 */
    handleOperateOrder (index, row) {
      this.$router.push({
        name: "powerorderDetail",
        params: {
          sn: row.sn,
          callback: this.GET_OrderList,
        },
      });
    },
    /** 导出订单 */
    handleExportOrders () {
      const { advancedForm: params } = this;
      API_order.exportOrders(params).then((res) => {
        const json = {
          sheet_name: "订单列表",
          sheet_values: res.map((item) => ({
            订单编号: item.sn,
            下单时间: Foundation.unixToDate(item.create_time),
            订单总额: Foundation.formatPrice(item.shop_order_price),
            收货人: item.ship_name,
            订单状态: item.order_status_text,
            付款人: item.pay_member_name,
            付款状态: item.pay_status_text,
            发货状态: item.ship_status_text,
            支付方式: item.payment_type === "ONLINE" ? "在线支付" : "线下支付",
            订单来源: item.client_type,
          })),
        };
        this.MixinExportJosnToExcel(json, "订单列表");
      });
    },

    /** 获取订单列表 */
    GET_OrderList () {
      const params = JSON.parse(JSON.stringify(this.params))
      if (params.trade_type) params.trade_form = params.trade_type, params.trade_type = undefined
      if (this.params.keywordValue) params[this.params.keywordType] = this.params.keywordValue
      if (params.refuse_type === 'REPLACE_GOODS') {
        params['mall_type'] = 4
      }
      API_refund.getRefundList(params)
        .then((res) => {
          this.loading = false;
          this.tableData = res;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table__fixed::before,
/deep/.el-table__fixed-right::before {
  background-color: transparent;
}

.en-table-layout .en-table-layout-toolbar .el-form-item {
  margin-bottom: 8px;
}

.auditForm {
  height: 400px;
  overflow-y: auto;
}

/deep/.el-radio {
  margin-bottom: 0;
}

.marginNone {
  margin-bottom: 0;
}

.text-tips {
  position: absolute;
  font-size: 12px;
  left: 0;
  top: 33px;
  line-height: normal;
}
</style>
